<priva-dialog
    width="750"
    [type]="DialogType.Dynamic"
    [title]="'REPORT_DIALOG.EDIT_KPI_NOTIFICATIONS.TITLE' | translate"
    [subTitle]="'REPORT_DIALOG.EDIT_KPI_NOTIFICATIONS.SUBTITLE' | translate"
    [buttons]="buttons()"
    (close)="close()"
    (buttonClick)="onDialogButtonClick($event)"
    [attr.data-test]="'kpi-notifications-dialog'"
>
    @if (isLoaded$ | async) {
        @if ((kpiNotificationSettings$ | async) && hasValidKpiLimits) {
            <p class="margin-bottom-3">
                {{ 'REPORT_DIALOG.EDIT_KPI_NOTIFICATIONS.MESSAGE' | translate }}
            </p>
            @for (formGroup of kpiNotificationForm; track formGroup; let i = $index) {
                @if (i | getRows: kpiSetLimits : ungroupedLimits; as row) {
                    @if (row.length) {
                        <priva-title [size]="PrivaTitleSize.Md" [title]="i | getTitle: kpiSetLimits" />
                        <priva-table
                            #kpiNotificationSet
                            type="separate"
                            idField="id"
                            [density]="'sm'"
                            [rows]="row"
                            [hasClickableRows]="false"
                            [selectable]="true"
                            (toggleSelectedItems)="toggleSelectedItems($event, i)"
                            class="kpi-set-table display-block margin-bottom-4"
                        >
                            @for (column of columnData; track column) {
                                <ng-template
                                    [priva-table-column]="column.title"
                                    [isContentWrapped]="column.wrap"
                                    [minWidth]="column.minWidth"
                                    [maxWidth]="column.maxWidth"
                                    [headerTemplateRef]="{
                                        template: headerTemplate,
                                        context: { data: column },
                                    }"
                                    let-kpiItem="row"
                                >
                                    @switch (column.id) {
                                        @case ('title') {
                                            {{ kpiItem.title }}
                                        }
                                        @case ('lowerLimit') {
                                            <div class="table__cell--editable">
                                                <priva-form-group [hasLabel]="false" [formGroup]="formGroup">
                                                    <input
                                                        priva-input
                                                        type="number"
                                                        [name]="kpiItem.id"
                                                        [formControl]="formGroup.get(kpiItem.id)"
                                                        [placeholder]="
                                                            'REPORT_DIALOG.EDIT_KPI_NOTIFICATIONS.TABLE.HEADER.LOWER_LIMIT.INPUT.PLACEHOLDER'
                                                                | translate
                                                        "
                                                        (input)="
                                                            !$event.target.value
                                                                ? (showValidationMessages = false)
                                                                : null
                                                        "
                                                    />
                                                    @if (showValidationMessages) {
                                                        @if (showValidation(i, kpiItem.id)) {
                                                            <priva-validation
                                                                data-test="custom-validation-error-messages"
                                                            >
                                                                @for (
                                                                    item of getItems(
                                                                        'kpi-lower-limit-max',
                                                                        FormControlValidationData
                                                                    );
                                                                    track item
                                                                ) {
                                                                    <priva-validation-item
                                                                        [icon]="item.iconClass"
                                                                    >
                                                                        <strong>
                                                                            {{
                                                                                'REPORT_DIALOG.EDIT_KPI_NOTIFICATIONS.LIMIT.VAlIDATION'
                                                                                    | translate
                                                                            }}
                                                                        </strong>
                                                                    </priva-validation-item>
                                                                }
                                                            </priva-validation>
                                                        }
                                                    }
                                                </priva-form-group>
                                            </div>
                                        }
                                    }
                                </ng-template>
                            }
                            <ng-template #headerTemplate let-column="data" class="padding-bottom-0">
                                {{ column.title | translate }}
                            </ng-template>
                        </priva-table>
                    }
                }
            }
        } @else {
            <p class="text-color-soft">
                {{ 'REPORT_DIALOG.EDIT_KPI_NOTIFICATIONS.NO_KPI_MESSAGE' | translate }}
            </p>
        }
    } @else {
        <priva-loader>
            <priva-spinner />
        </priva-loader>
    }
</priva-dialog>
